import { Button, Modal } from "antd";
import { useTranslation } from "react-i18next";
import { ModalSizes } from "../../constants";
import { HistoryRecordType, HistoryViewItem } from "../types";
import { HistoryView } from "./HistoryView";

type Props = {
  isOpen: boolean;
  item: HistoryViewItem;
  type: HistoryRecordType;
  translationRootPath: string;
  onCancel: VoidFunction;
};

export const HistoryModal = ({ isOpen, item, translationRootPath, onCancel, type }: Props) => {
  const { t } = useTranslation();

  return (
    <Modal
      title={t("history.title")}
      width={ModalSizes.HUGE}
      open={isOpen}
      onCancel={onCancel}
      footer={<Button onClick={onCancel}>{t("common.close")}</Button>}
    >
      <HistoryView item={item} translationRootPath={translationRootPath} type={type} />
    </Modal>
  );
};
